import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/employee`;

/** /salarie/connexion/lien/:token — connexion directe via le lien envoyé par l'employeur (usage unique, expirant). */
export default function EmployeeLoginLink() {
  const { token } = useParams(); const nav = useNavigate(); const [err, setErr] = useState(null);
  useEffect(() => { axios.post(`${API}/login-link`, { token }, { withCredentials: true }).then(() => nav("/salarie", { replace: true })).catch((e) => setErr(e.response?.data?.detail || "Lien invalide.")); }, [token, nav]);
  return <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-6" data-testid="emp-login-link">
    {err ? <div className="max-w-sm text-center space-y-3"><div className="font-heading text-xl font-bold">Lien de connexion</div><p className="text-sm text-slate-300" data-testid="emp-login-link-error">{err}</p><a href="/salarie/connexion" className="inline-block h-11 px-5 leading-[44px] rounded-xl bg-white text-slate-900 text-sm font-medium" data-testid="emp-login-link-fallback">Se connecter avec mon mot de passe</a></div>
      : <div className="flex items-center gap-2 text-sm"><Loader2 className="w-5 h-5 animate-spin" />Connexion en cours…</div>}
  </div>;
}
